<template>
  <a-layout id="layout">
    <a-layout-content class="layout-content">
      <slot />
    </a-layout-content>
  </a-layout>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
#layout {
  height: 100vh;
  position: relative;

  &::before {
    content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.6;
    background-image: url('../../assets/logo.png');
    background-repeat: no-repeat;
    background-position: 0% 100%;
  }

  .layout-content {
    margin: 0;
    height: 100vh;
    width: 100vw;
    position: relative;
  }
}
</style>
